<template>
  <v-card elevation="12" style="background: white !important;" class="pa-4 black--text">
    <v-card-title>
      Registration Complete
    </v-card-title>
    <v-card-text>
      A verification email has been sent to the email provided.
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn to="/" class="main-btn">Home</v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped lang="scss">
@import "~vuetify/src/styles/settings/_variables";

h3.tagline {
  font-size: 35px;
  font-weight: 500;
  color: #171b5b;
  margin: 35px 0;
}

.form-pinch {
  padding: 10% 10% 0 10%;
}

@media #{map-get($display-breakpoints, 'md-and-up')} {
  .no-left-pad-md {
    padding-left: 0;
  }
}
</style>

<script>
import logo from "../../assets/images/logo.png";

export default {
  name: "completion",
  data() {
    return {
      logo: logo,
    };
  },
};
</script>
